/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useRef } from "react";

export default function useDragScroll() {
  const scrollRef = useRef(null);

  const handleMouseDown = (e) => {
    const container = scrollRef.current;
    if (!container) return;

    const canScroll = container.scrollWidth > container.clientWidth;
    if (!canScroll) return;

    if (e.target.closest(".category-card")) return;

    container.style.cursor = "grabbing";

    const startX = e.pageX;
    const scrollLeft = container.scrollLeft;
    let isDragging = true;

    const onMove = (ev) => {
      if (!isDragging) return;
      const walk = (startX - ev.pageX) * 2;
      container.scrollLeft = scrollLeft + walk;
    };

    const onUp = () => {
      isDragging = false;
      container.style.cursor = "grab";
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
    };

    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
  };

  const handleWheel = (e) => {
    const container = scrollRef.current;
    if (!container) return;

    const canScroll = container.scrollWidth > container.clientWidth;
    if (canScroll && Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      container.scrollLeft += e.deltaY;
    }
  };

  return { scrollRef, handleMouseDown, handleWheel };
}
